import * as msal from "@azure/msal-browser";
const msalConfig = {
  auth: {
    clientId: "5bf1b039-e70b-444e-860d-79dfbe3a1ced",
    authority:
      "https://login.microsoftonline.com/ChristLifeFaithMinistries.onmicrosoft.com",
    redirectUri:
      process.env.NODE_ENV === "production"
        ? "https://christlifefaithministries.org/"
        : "http://localhost:8080/"
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};
const MsalInstance = {
  install(vue) {
    //debugger;
    vue.prototype.$msalInstance = new msal.PublicClientApplication(msalConfig);
  }
};
export default MsalInstance;
